/**
 * Shared helpers for menu input handlers.
 */

import { getSkinForTank } from '../../skins/storage';
import { lookupTank } from '../../tanks';
import { getAllStageIds } from '../../stages';

/** Get the effective display color for a tank (skin override or default). */
export function tankColor(tankId: string): number {
  return getSkinForTank(tankId).color ?? lookupTank(tankId).visual.bodyColor;
}

/** Pick a random theme ID for the random stage preview. Uses Math.random() (visual-only). */
export function pickRandomThemeId(): string {
  const ids = getAllStageIds().filter(id => id !== 'random');
  return ids[Math.floor(Math.random() * ids.length)];
}

/** Generate a hash-like seed from current time. */
export function makePreviewSeed(): number {
  return (Date.now() * 2654435761) >>> 0;
}
